import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react'
import { ApiErrorTypes } from 'ogram-react'

import { Select } from '../../../../../components/form/select/select'
import { useQuery, useStore } from '../../../../../utils/mst-hooks'
import { shiftsListStore } from '../../../../../models-ui/shifts-list'
import './shifts-designation-filter.scss'

const ALL_DESIGNATIONS = -1

type Props = {
  onDesignationChange: () => void
}

export const ShiftsDesignationFilter = observer(({ onDesignationChange }: Props) => {
  const { t } = useTranslation()
  const { professionList, getProfessions } = useStore().data

  const { isLoading } = useQuery(() => getProfessions({}), {
    filterError: [ApiErrorTypes.ClientError],
  })

  const options = [
    { key: String(ALL_DESIGNATIONS), label: t('shifts_attendance_list.all_designations'), value: ALL_DESIGNATIONS },
    ...professionList.map(profession => ({
      key: String(profession.id),
      label: profession.name,
      value: profession.id,
    })),
  ]

  if (isLoading) {
    return null
  }

  const currentValue = shiftsListStore.searchFilters.workCategoryId ?? ALL_DESIGNATIONS

  return (
    <div className="ShiftsDesignationFilter">
      <Select
        value={currentValue}
        options={options}
        onChange={(value: number) => {
          shiftsListStore.setWorkCategoryId(value === ALL_DESIGNATIONS ? null : value)
          onDesignationChange()
        }}
        className="ShiftsDesignationFilter__select"
      />
    </div>
  )
})
